/**
 * Tipos de evento da agenda interna da Piperz.
 *
 * Espelha App\Enums\Calendar\EventType no saas — os valores viajam crus na API,
 * então os dois lados têm de andar juntos.
 */
export enum EventType {
  ENSAIO = 0,
  BLOQUEIO = 1,
  COMPROMISSO_PESSOAL = 2,
  ENSAIO_FLEXIVEL = 3,
}

/** Os únicos tipos que o criativo cria por conta própria; ensaio é da operação. */
export const SELF_SERVICE_EVENT_TYPES = [EventType.BLOQUEIO, EventType.COMPROMISSO_PESSOAL]

export function getEventTypeDescription(type: EventType) {
  switch (type) {
    case EventType.ENSAIO:
      return 'Ensaio'
    case EventType.BLOQUEIO:
      return 'Bloqueio'
    case EventType.COMPROMISSO_PESSOAL:
      return 'Compromisso Pessoal'
    case EventType.ENSAIO_FLEXIVEL:
      return 'Ensaio Flexível'
    default:
      return ''
  }
}
